import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {ApiService} from '../shared/api.service';

@Injectable()
export class ProfileApiService {

  constructor(private Api: ApiService) {
  }

  getTalentProfile(id: string): Observable<Talent.Profile> {
    return this.Api.httpWrapper<Talent.Profile>({
      method: 'GET',
      url: `${environment.apiHost}/v1/talent/${id}`
    });
  }

  getSubmittalProfile(id: string): Observable<Talent.Profile> {
    return this.Api.httpWrapper<Talent.Profile>({
      method: 'GET',
      url: `${environment.apiHost}/v1/submittal/${id}`
    });
  }

  saveProfile(profileId: string, content: Talent.Profile): Observable<void> {
    return this.Api.httpWrapper<void>({
      method: 'POST',
      url: `${environment.apiHost}/v1/toolkit/candidate/${profileId}/profile`,
      data: content,
      authenticated: true
    });
  }

  saveRate(profileId: string, rate: number): Observable<void> {
    return this.Api.httpWrapper<void>({
      method: 'POST',
      url: `${environment.apiHost}/v1/toolkit/candidate/${profileId}/rate`,
      data: rate,
      authenticated: true
    });
  }

  saveSalary(profileId: string, salary: string): Observable<void> {
    return this.Api.httpWrapper<void>({
      method: 'POST',
      url: `${environment.apiHost}/v1/toolkit/candidate/${profileId}/salary`,
      data: salary,
      authenticated: true
    });
  }

  saveSubmittalFeedback(profileId: string, feedback: SubmittalFeedbackBody): Observable<void> {
    return this.Api.httpWrapper<void>({
      method: 'POST',
      url: `${environment.apiHost}/v1/submittal/${profileId}/feedback`,
      data: feedback,
      authenticated: true
    });
  }
}
